import React from "react";
import PropTypes from "prop-types";
import SectionButton from "./SectionButton";

const SectionButtonGroup = ({ sections, activeSection, onSectionClick }) => {
  return (
    <div className="d-flex gap-2 mb-3">
      {sections.map((section) => (
        <SectionButton
          key={section.id}
          label={section.label}
          isActive={activeSection === section.id}
          onClick={() => onSectionClick(section.id)}
          targetId={section.id}
        />
      ))}
    </div>
  );
};

SectionButtonGroup.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeSection: PropTypes.string.isRequired,
  onSectionClick: PropTypes.func.isRequired,
};

export default SectionButtonGroup;
